import { ArrowLeft, CheckCircle, Mail } from 'lucide-react'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Container } from '@/components/Container'
import mccLogo from '@/assets/mcc_logo.png'

export default function ForgotPasswordSuccess() {
  const navigate = useNavigate()
  const { email } = useSearch({ from: '/password-requested' })

  const handleBackToLogin = () => {
    navigate({ to: '/login' })
  }

  return (
    <Container>
      <div className="flex flex-col items-center gap-6">
        <img
          src={mccLogo}
          alt="Maranatha Christian Church"
          className="w-48 sm:w-52"
        />
        <div className="w-full max-w-lg rounded-lg border bg-white p-6 shadow-sm">
          <div className="space-y-4">
            <div className="flex items-center gap-2 mb-4">
              <CheckCircle className="h-6 w-6 text-green-600" />
              <span className="text-xl sm:text-2xl font-semibold">
                Email Sent!
              </span>
            </div>

            <Alert className="border-green-200 bg-green-50">
              <Mail className="h-4 w-4 text-green-600" />
              <AlertDescription className="text-green-800">
                We've sent password reset instructions to{' '}
                <strong>{email}</strong>
              </AlertDescription>
            </Alert>

            <div className="text-sm text-gray-600 space-y-2">
              <p>
                Please check your email and follow the instructions to reset
                your password.
              </p>
              <p>
                If you don't see the email within a few minutes, check your spam
                folder.
              </p>
            </div>

            <Button onClick={handleBackToLogin} className="w-full mt-6">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Login
            </Button>
          </div>
        </div>
      </div>
    </Container>
  )
}
